<ng-container *ngIf="currentStep as step; else emptyState">
  <div class="demo-wrapper">
    <!-- <div class="demo-rfq-header">
      <h2 class="demo-rfq-title">{{ rfqName?.trim() || 'Enter RFQ Name' }}</h2>
    </div> -->
    <div class="top-part-name">
      <div class="form-control-static">
        <div class="col-sm-12 ">
          <h2 class="demo-rfq-title">{{ rfqName?.trim() || 'Enter RFQ Name' }}</h2>
        </div>
      </div>
    </div>
    <div class="demo-container">
      <header class="demo-header">
        <div class="progress-area">
          <div class="progress-track" role="progressbar" [attr.aria-valuenow]="currentIndex + 1"
            [attr.aria-valuemin]="1" [attr.aria-valuemax]="totalSteps">
            <span class="progress-segment" *ngFor="let step of steps; let idx = index"
              [class.progress-segment--active]="idx <= currentIndex">
            </span>
          </div>
          <div class="demo-title">
            <span class="demo-step-count">{{currentIndex + 1}} of {{totalSteps}}</span>
            <span class="demo-label">Cost Builder Demo</span>
          </div>
        </div>
        <button type="button" class="close-button" (click)="onClose()" aria-label="Close demo">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M0.146447 0.853554C-0.0488156 0.658291 -0.0488156 0.341709 0.146447 0.146447C0.341709 -0.0488155 0.658292 -0.0488155 0.853554 0.146447L6 5.29289L11.1464 0.146447C11.3417 -0.0488155 11.6583 -0.0488155 11.8536 0.146447C12.0488 0.341709 12.0488 0.658291 11.8536 0.853554L6.70711 6L11.8536 11.1464C12.0488 11.3417 12.0488 11.6583 11.8536 11.8536C11.6583 12.0488 11.3417 12.0488 11.1464 11.8536L6 6.70711L0.853554 11.8536C0.658292 12.0488 0.341709 12.0488 0.146447 11.8536C-0.048815 11.6583 -0.048815 11.3417 0.146447 11.1464L5.29289 6L0.146447 0.853554Z" fill="black"/>
          </svg>
        </button>
      </header>

      <section class="demo-media" aria-live="polite">
        <ng-container [ngSwitch]="step.media.type">
          <video *ngSwitchCase="'video'" [src]="getMediaUrl(step)" autoplay controls playsinline preload="metadata">
            Your browser does not support the video tag.
          </video>
          <img *ngSwitchCase="'image'" [src]="getFullS3Url(step.media.source)" [alt]="step.title || 'Cost builder demo'">
          <div *ngSwitchDefault class="media-fallback">
            Media unavailable for this step.
          </div>
        </ng-container>
      </section>

      <section class="demo-body">
        <h3>{{step.title}}</h3>
        <!-- <p>{{step.description}}</p> -->
         <ul>
          <li>
            Cost builder is an <strong>optional</strong> tool for you to estimate your quotes.
          </li>
          <li>
            Add <strong>Materials, Tooling, Processes, or Additional Costs</strong> to build your quote. The Cost you input for each field will <strong>automatically adjust the Unit Cost</strong> for each quantity listed on the quote.
          </li>
         </ul>
      </section>
    </div>
    <footer class="demo-actions">
      <button type="button" class="secondary-button" (click)="goToPrevious()" [disabled]="!canGoBack">
        Back
      </button>
      <button type="button" class="primary-button" (click)="onPrimaryAction()">
        {{ primaryActionLabel }}
      </button>
    </footer>
  </div>
</ng-container>

<ng-template #emptyState>
  <div class="demo-empty-state">
    Cost builder demo is not available at the moment.
  </div>
</ng-template>